module.exports = __webpack_public_path__ + "static/social_branding-a75dc4413fe7620df7a10e05e9770fa0.jpg";